export interface OnboardingErrorStateProps {
  variant: 'not_found' | 'expired';
  /** Detalhe técnico opcional mostrado em pequenino (ex: mensagem
   * da edge function). Cuidado: não expor PII nem stack trace. */
  details?: string | undefined;
}

const COPY = {
  not_found: {
    title: 'Link não encontrado',
    description:
      'Este link de questionário não foi encontrado ou é inválido. Confira se você copiou a URL completa; se o problema persistir, peça um novo link à consultora.',
  },
  expired: {
    title: 'Este link expirou',
    description:
      'O prazo para responder este questionário passou. Fale com a consultora para receber um novo link — leva menos de um minuto.',
  },
} as const;

/**
 * Estado de erro genérico da rota `/onboarding/:token`. Duas variantes
 * (`not_found` e `expired`) cobrem 95% dos casos de erro; o
 * `details` técnico só aparece quando a edge function devolve
 * mensagem útil para o user reportar à consultora.
 *
 * Tom de voz: **nunca culpa o user**. Usa "este link" em vez de "seu
 * link", evita palavras técnicas. Contato é sempre "fale com a
 * consultora" (humano, acolhedor).
 */
export function OnboardingErrorState({ variant, details }: OnboardingErrorStateProps) {
  const copy = COPY[variant];
  return (
    <div
      role="alert"
      className="rounded-lg border border-border bg-card p-6 text-center shadow-sm sm:p-8"
    >
      <h1 className="text-xl font-semibold text-foreground sm:text-2xl">{copy.title}</h1>
      <p className="mt-3 text-sm text-muted-foreground sm:text-base">{copy.description}</p>
      {details ? <p className="mt-4 text-xs italic text-muted-foreground/80">{details}</p> : null}
    </div>
  );
}
